module.exports = __webpack_public_path__ + "static/img/male-5.ca20a571.webp";